import styled from 'styled-components'
import COLORS from '@colors'

export const Button = styled.button`
  background-color: ${COLORS.gray45};
  border: 0;
  border-radius: 4px;
  color: ${COLORS.white};
  height: 40px;
  margin-top: 16px;
  outline: 0;
  width: 100%;
`
